// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ol class=\"index data\">\n  <span inject=\"questionnaire-summary\"></span>\n</ol>\n";
},"useData":true});
